import { lazy, Suspense } from "react";
import type { RouteObject } from "react-router-dom";
import Home from "@/pages/home/page";
import NotFound from "@/pages/NotFound";

const Adopt = lazy(() => import("@/pages/adopt/page"));
const SmartAdopt = lazy(() => import("@/pages/smart-adopt/page"));
const Farm = lazy(() => import("@/pages/farm/page"));
const Experience = lazy(() => import("@/pages/experience/page"));
const Urban = lazy(() => import("@/pages/urban/page"));
const Feature = lazy(() => import("@/pages/feature/page"));
const Community = lazy(() => import("@/pages/community/page"));
const Solution = lazy(() => import("@/pages/solution/page"));
const Portal = lazy(() => import("@/pages/portal/page"));
const Circle = lazy(() => import("@/pages/circle/page"));
const FoodStreet = lazy(() => import("@/pages/food-street/page"));
const Login = lazy(() => import("@/pages/login/page"));
const Register = lazy(() => import("@/pages/register/page"));

function PageLoader() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background-50">
      <div className="flex items-center gap-3 text-foreground-500">
        <i className="ri-loader-4-line animate-spin text-2xl"></i>
        <span className="whitespace-nowrap text-sm">正在加载…</span>
      </div>
    </div>
  );
}

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/adopt",
    element: (
      <Suspense fallback={<PageLoader />}>
        <Adopt />
      </Suspense>
    ),
  },
  {
    path: "/smart-adopt",
    element: (
      <Suspense fallback={<PageLoader />}>
        <SmartAdopt />
      </Suspense>
    ),
  },
  {
    path: "/farm",
    element: (
      <Suspense fallback={<PageLoader />}>
        <Farm />
      </Suspense>
    ),
  },
  {
    path: "/experience",
    element: (
      <Suspense fallback={<PageLoader />}>
        <Experience />
      </Suspense>
    ),
  },
  {
    path: "/feature",
    element: (
      <Suspense fallback={<PageLoader />}>
        <Feature />
      </Suspense>
    ),
  },
  {
    path: "/community",
    element: (
      <Suspense fallback={<PageLoader />}>
        <Community />
      </Suspense>
    ),
  },
  {
    path: "/solution",
    element: (
      <Suspense fallback={<PageLoader />}>
        <Solution />
      </Suspense>
    ),
  },
  {
    path: "/portal",
    element: (
      <Suspense fallback={<PageLoader />}>
        <Portal />
      </Suspense>
    ),
  },
  {
    path: "/circle",
    element: (
      <Suspense fallback={<PageLoader />}>
        <Circle />
      </Suspense>
    ),
  },
  {
    path: "/food-street",
    element: (
      <Suspense fallback={<PageLoader />}>
        <FoodStreet />
      </Suspense>
    ),
  },
  {
    path: "/urban",
    element: (
      <Suspense fallback={<PageLoader />}>
        <Urban />
      </Suspense>
    ),
  },
  {
    path: "/login",
    element: (
      <Suspense fallback={<PageLoader />}>
        <Login />
      </Suspense>
    ),
  },
  {
    path: "/register",
    element: (
      <Suspense fallback={<PageLoader />}>
        <Register />
      </Suspense>
    ),
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;